import * as React from 'react';
import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { ProductDetailTitleView } from '@grandvisionhq/fun-products';
import { useProductDetailContext } from '../../../Context/ProductDetailContext.js';

const LensesProductTitle = ()=>{
    const { activeVariant  } = useProductDetailContext();
    if (!CommerceToolsApi.isLenses(activeVariant)) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(ProductDetailTitleView, {
        title: activeVariant.brand,
        subtitle: activeVariant.replacementFrequency
    });
};

export { LensesProductTitle };
//# sourceMappingURL=LensesProductTitle.js.map
